module.exports = __webpack_public_path__ + "static/img/teamData.3815eeca.svg";